import React from 'react';

import { LegacyText, LegacyBox } from '@gogame/components';
import { DateRangeFormatter } from '@gogame/intl-ts';

export const OwnerListItem = ({ name, period }) => {
  return (
    <LegacyBox gutter={4}>
      <LegacyText>
        {name} (<DateRangeFormatter value={period} template={'LL'} />)
      </LegacyText>
    </LegacyBox>
  );
};
